import { Lang } from 'cat-shared/utils'

export const APP_NAME = 'Can Answer That ?'
export const APP_NAME_SHORT = 'CAT'
export const APP_EMAIL = 'cat.web.app@gmail.com'
export const STRIPE_HOME_PAGE = 'https://stripe.com'
export const FB_FUN_PAGE = 'https://www.facebook.com/profile.php?id=61572007547329'

export const DATE_TIME_FORMAT = 'd MMMM yyyy, hh:mm:ss'

export const DATE_PICKER_LOCALES = {
  [Lang.EN]: 'en-US',
  [Lang.PL]: 'pl-PL',
}

export const TEN_MINUTES_IN_MS = 1000 * 60 * 10
export const MIN_REQ_TIME_MS = 200

export const AVATAR_SIZE = 250
export const COUNTRY_FLAG_SIZE = 48

export const DEFAULT_THEME = 'light'
export const DEFAULT_LANG = Lang.EN

export const YES = 'yes'
export const NO = 'no'

export const PAGES_CONFIG = {
  '/': {
    path: '/',
    title: APP_NAME,
  },
  '/auth': {
    path: '/auth',
    title: APP_NAME + ' - Authentication',
  },
  '/home': {
    path: '/home',
    title: APP_NAME + ' - Home Page',
  },
  '/browse': {
    path: '/browse',
    title: APP_NAME + ' - Question Browser',
  },
  '/random': {
    path: '/random',
    title: APP_NAME + ' - Randomizer',
  },
  '/create': {
    path: '/create',
    title: APP_NAME + ' - Create Question',
  },
  '/question': {
    path: '/question',
    title: APP_NAME + ' - Question',
  },
  '/profile': {
    path: '/profile',
    title: APP_NAME + ' - Profile',
  },
  '/settings': {
    path: '/settings',
    title: APP_NAME + ' - Settings',
  },
  '/about': {
    path: '/about',
    title: APP_NAME + ' - About',
  },
  '/best': {
    path: '/best',
    title: APP_NAME + ' - Best',
  },
}

if (process.env.NODE_ENV === 'development') {
  PAGES_CONFIG['/ui'] = {
    path: '/ui',
    title: APP_NAME + ' - UI Building Blocks',
  }
}
